module.exports = __webpack_public_path__ + "static/media/Instagram.3f5e3a81.svg";